<ng-container *ngFor="let item of children" [appRenderNode]="item"> </ng-container>